<!--
 * @Description: 新能源油品库
 * @Author: ywz
 * @Date: 2025-07-15
 -->
<template>
  <div class="settle-manager">
    <el-table :data="list" style="width: 100%" tooltip-effect="light">
      <el-table-column
        prop="outboundNo"
        label="出库流水号"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="contractCode"
        label="合同编号"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="itemAttribute"
        label="物料属性"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="itemName"
        label="物料名称"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="itemCode"
        label="物料编码"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="primaryQuantity"
        label="原发数"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="receiveQuantity"
        label="实收数"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="takeOrderCode"
        label="提货单号"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="orderCode" label="订单号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="outboundTime"
        label="出库时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        label="业务类型"
        :formatter="formatBusinessType"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="outReservoirAreaName"
        label="发货库区名称"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="outReservoirAreaCode"
        label="发货库区编码"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="oilTankCode"
        label="罐号"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="receiveArea"
        label="收货区域"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="inStorageTime"
        label="收货入厂时间"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        label="业务员"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="deliveryWay"
        label="配送方式"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="orderStatus"
        label="订单状态"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="vehicleBoatNo"
        label="车船号"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="driverName"
        label="司机"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="followType"
        label="单据类型"
        width="120"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'inventoryCollectOut',
  data () {
    return {
      dialogVisible: false,
      pageNo: 1,
      pageSize: 100,
      printDialogInfo: '',
      form: {
        org: '',
        reservoirAreaCode: '',
        oilTankCode: '',
        outboundTime: ''
      },
      acceptExtArr: ['xls', 'xlsx'],
      sizeOptions: [
        {
          label: '10',
          value: 10
        },
        {
          label: '20',
          value: 20
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        }
      ],
      businessTypeOptions: [
        {
          value: 'OUT_SALES',
          label: '销售出库'
        },
        {
          value: 'OUT_TRANSPORT',
          label: '调拨出库'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      list: 'getOrderOutboundList',
      listState: 'getOrderOutboundListState',
      LOV_CODE: 'LOV_CODE'
    }),
    ...mapState({
      outParams: (state) => state.cache.outParams
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  methods: {
    ...mapActions([
      'getOrderOutboundList',
      'exportOrderOutboundList',
      'getRepositoryData',
      'getOilTankData'
    ]),
    formatBusinessType (row) {
      const info = this.businessTypeOptions.find(
        (item) => item.value === row.businessType
      )
      return info.label
    },
    handleAdd () {
      this.dialogVisible = true
      this.printDialogInfo = {}
    },
    handleEdit (row) {
      this.dialogVisible = true
      this.printDialogInfo = row
    },
    // 搜索
    handleSearch () {
      const { reservoirAreaCode, oilTankCode, timeStart, timeEnd } =
            this.outParams
      const payload = {
        reservoirAreaCode,
        oilTankCode,
        outboundTimeStart: timeStart,
        outboundTimeEnd: timeEnd
      }
      this.getOrderOutboundList(payload)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getOrderOutboundList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getOrderOutboundList({ pageNo: val })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.pageNo = 1
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 导出
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          const { reservoirAreaCode, oilTankCode, timeStart, timeEnd } =
            this.outParams
          const payload = {
            reservoirAreaCode,
            oilTankCode,
            outboundTimeStart: timeStart,
            outboundTimeEnd: timeEnd
          }
          this.exportOrderOutboundList({
            ...payload,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }).then((res) => {
            function createDownloadFile () {
              let blob = new Blob([res])
              let link = document.createElement('a')
              link.download = '出库单列表.xls'
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blob)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
            createDownloadFile()
            this.$message.success('导出成功')
          })
        })
        .catch(() => {})
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>
<style lang="scss" scoped>
.upload-btn {
  display: inline-block;
  margin: 0 10px;
}
.width100 {
  width: 100px;
}
.export-row {
  margin-top: 10px;
}
.mr10 {
  margin-right: 10px;
}
</style>
